import { render, staticRenderFns } from "./ModalHeadlineWrap.vue?vue&type=template&id=9c25d982&scoped=true"
import script from "./ModalHeadlineWrap.vue?vue&type=script&lang=js"
export * from "./ModalHeadlineWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c25d982",
  null
  
)

export default component.exports